<template>
  <div style="position:relative">
    <div v-if="vEls" class="outer" @click="vEls=false"></div>
    <div class="sel-el el-item" @click="vEls = true" v-if="els.length>0">
      <div><i class="material-icons">{{ selectEl.icon }}</i></div>
      <div>{{ selectEl.name }}</div>
      <div class="arrow-down"><i class="material-icons">arrow_drop_down</i></div>
    </div>

    <div v-if="vEls" @click="vEls=false" class="els">
      <div v-for="(el, idx) in els" :key="'el-'+idx" @click="clickEl(el)" class="el-item item">
        <div><i class="material-icons">{{ el.icon }}</i></div>
        <div>{{ el.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:['ele','formtypes'],
    created() {
      this.els = this.formtypes;
      this.selectEl = find(this.els, 'types', this.ele);
    },
    watch: {
      ele(n) {
        this.selectEl = find(this.els, 'types', this.ele);
      }
    },
    data() {
      return {
        selectEl: {'icon': 'short_text', 'name': '단답형', 'types': 'text'},
        vEls: false,
        els: []
      }
    },
    methods: {
      clickEl(el) {
        this.selectEl = el;
        this.$emit('clickEl', el.types);
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  .sel-el
    background-color #f0f0f0
    padding 8px
    width 160px
    cursor pointer


  .els
    position absolute
    width 180px
    background white
    box-shadow 0px 3px 8px 2px #999
    bottom -250px
    left 0
    z-index 10


  .el-item
    padding 8px
    font-size 0.9rem
    display table

  .item:hover
    width 164px
    background-color #eee
    cursor pointer

  .el-item div
    display table-cell
    vertical-align middle
    font-size 0.9rem
  .el-item div:first-child
    font-size 1.2rem
    padding-top 4px
    padding-right 8px
    color #555
    width 32px

  .arrow-down
    color #787878
    width 20px

  .outer
    position fixed
    top 0
    left 0
    right 0
    bottom 0

</style>
